export enum StoreTaxRegistrationStatus {
    VAT = 'vat',
    NON_VAT = 'non_vat',
    NONE = 'none',
}